export { default } from "./queries";
